var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TeamNameMasterComponent',{attrs:{"typeName":"設備点検 チーム名設定","type":4,"settionStrageName":"TeamNameMasterStorageItemName"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }